var _path, _path2, _path3, _g, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExamRegister(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6045_3794)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6402 34.7039C31.0938 34.7039 34.7042 31.0936 34.7042 26.6399C34.7042 22.1863 31.0938 18.5759 26.6402 18.5759C22.1865 18.5759 18.5762 22.1863 18.5762 26.6399C18.5762 31.0936 22.1865 34.7039 26.6402 34.7039Z",
    fill: "#E71D2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6387 20.9761V26.6401H32.3027",
    stroke: "white",
    strokeWidth: 2.25
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6045_3794",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 32,
    height: 34
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1489 1.29614H1.29688V34.6201H15.1089V26.8561L32.1489 9.43214V1.29614Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6045_3794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7473 3.69604V27.264C29.7473 30 27.5273 32.22 24.7913 32.22H8.49531C5.84331 32.22 3.69531 30.072 3.69531 27.42V3.69604H29.7473Z",
    stroke: "black",
    strokeWidth: 2.25
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69531 9.85205H23.7473",
    stroke: "black",
    strokeWidth: 2.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69531 16.0559H18.5753",
    stroke: "black",
    strokeWidth: 2.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6045_3794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamRegister);
export default __webpack_public_path__ + "static/media/exam-register.7ed792e3fd09af7ecd58d83c17cf35c0.svg";
export { ForwardRef as ReactComponent };